import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import Menu from '../../../core/layout/Menu';
import ConfirmDialogContainer from './ConfirmDialogContainer';
import Button from '../../../core/form/Button';
import UnReadeMessageCountContainer from '../../message/components/UnReadeMessageCountContainer';
import { Roles } from '../../../core/util';
import PermissionValidator from '../../../core/layout/PermissionValidator';
import WarningContractBlockDialogContainer from './dialogs/WarningContractBlockDialogContainer';
import BillReminderDialogContainer from './dialogs/BillReminderDialogContainer';
import MigrationDialogContainer from './dialogs/MigrationDialogContainer';
// import PendingSuspectUsageAlertCountContainer
//   from '../../suspect-usage-alerts/components/PendingSuspectUsageAlertCountContainer';

class MainScene extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  componentDidMount() {
    setTimeout(() => {
      window.HubSpotConversations && window.HubSpotConversations.widget && window.HubSpotConversations.widget.load();
    }, 3000);
  }

  handleLogout = () => {
    try {
      window.HubSpotConversations.widget.remove();
    } catch (error) {
    } finally {
      const selectedExtraColumns = localStorage.getItem('selectedExtraColumns');
      const environment = localStorage.getItem('environment');
      localStorage.clear();
      if (selectedExtraColumns) {
        localStorage.setItem('selectedExtraColumns', selectedExtraColumns);
      }
      if (environment) {
        localStorage.setItem('environment', environment);
      }
      window.location.reload();
    }
  };

  menuItems =
    localStorage.getItem('environment')?.indexOf('seed') > -1
      ? [
          {
            type: 'submenu',
            key: 'admin',
            title: 'Admin',
            icon: 'user',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
            groups: [
              {
                group: 'System Configuration',
              },
            ],
            items: [
              {
                label: 'System Translations',
                link: '/system-translations',
                group: 'System Configuration',
                icon: 'global',
                key: 'translations',
              },
              {
                label: 'Systems Localization',
                link: '/localization',
                group: 'System Configuration',
                icon: 'font-size',
                key: 'localization',
              },
            ],
          },
          {
            type: 'submenu',
            key: 'content-report',
            title: 'Content Reports',
            icon: 'control',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
            items: [
              {
                label: 'Placement Item History',
                key: 'placement-test-items-history',
                link: '/placement-test-items-history',
                group: 'Reports',
                icon: 'info-circle-o',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Unit Items Errors',
                key: 'reports-unit-errors',
                link: '/reports/unit-errors',
                group: 'Reports',
                icon: 'exclamation-circle-o',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
              {
                label: 'Unit Items Execution Stats',
                key: 'unit-items-execution-stats',
                link: '/unit-items-execution-stats',
                group: 'Reports',
                icon: 'warning',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Unit Average Execution Time',
                key: 'unit-average-execution-time',
                link: '/unit-average-execution-time',
                group: 'Reports',
                icon: 'hourglass',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Unit Ratings',
                key: 'unit-ratings',
                link: '/unit-ratings',
                group: 'Reports',
                icon: 'star',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Mastery Items Execution Stats',
                key: 'mastery-items-execution-stats',
                link: '/mastery-items-execution-stats',
                group: 'Reports',
                icon: 'warning',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
            ],
          },
          {
            type: 'menu',
            title: 'Certification Test',
            key: 'certification-test-executions',
            link: '/certification-test-executions',
            icon: 'contacts',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CERTIFICATION_TEST_PROFESSIONAL],
          },
          {
            type: 'menu',
            key: 'messages',
            link: '/messages',
            icon: 'message',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
            title: (
              <UnReadeMessageCountContainer>
                <span style={{ color: 'hsla(0,0%,100%,.65)' }}>Messages</span>
              </UnReadeMessageCountContainer>
            ),
          },
          {
            type: 'submenu',
            key: 'kpis',
            title: 'KPIs',
            icon: 'desktop',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
            items: [
              {
                label: 'Customer Success',
                icon: 'solution',
                key: 'customer-succes',
                link: '/kpis/customer-success',
              },
              {
                label: 'Learning',
                icon: 'book',
                key: 'learning',
                link: '/kpis/learning',
              },
              {
                label: 'Content',
                icon: 'read',
                key: 'content',
                link: '/kpis/content',
              },
            ],
          },
        ]
      : [
          {
            title: 'Dashboard',
            icon: 'dashboard',
            link: '/',
            type: 'menu',
            key: 'dashboard-menu',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN, Roles.CERTIFICATION_TEST_PROFESSIONAL],
          },
          {
            title: 'Profile',
            icon: 'idcard',
            link: '/profile',
            type: 'menu',
            key: 'profile',
          },
          {
            type: 'submenu',
            key: 'admin',
            title: 'Admin',
            icon: 'user',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
            groups: [
              {
                group: 'Admin Register',
              },
              {
                group: 'System Configuration',
              },
            ],
            items: [
              {
                label: 'Characters',
                link: '/characters',
                group: 'Admin Register',
                icon: 'user',
                key: 'characters',
              },
              {
                label: 'System Translations',
                link: '/system-translations',
                group: 'System Configuration',
                icon: 'global',
                key: 'translations',
              },
              {
                label: 'Systems Localization',
                link: '/localization',
                group: 'System Configuration',
                icon: 'font-size',
                key: 'localization',
              },
              {
                label: 'Whitelabel',
                link: '/whitelabel-configs',
                group: 'System Configuration',
                icon: 'fork',
                key: 'whitelabelconfig',
              },
            ],
          },
          {
            type: 'submenu',
            key: 'basicregister',
            title: 'Basic Register',
            icon: 'folder',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
            items: [
              {
                label: 'Contracts',
                key: 'contracts',
                link: '/contracts',
                icon: 'file',
              },
              {
                label: 'Billing',
                key: 'billing',
                link: '/billing',
                icon: 'shopping-cart',
              },
              {
                label: 'Checkout links',
                key: 'checkout-links',
                link: '/checkout-links',
                allowedFor: [Roles.ADMIN],
                group: 'Organizations',
                icon: 'link',
              },
            ],
          },
          {
            type: 'submenu',
            key: 'content',
            title: 'Content',
            icon: 'book',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN, Roles.DISTRIBUTOR_CONTENT_ADMIN],
            groups: [
              {
                group: 'Course',
              },
              {
                group: 'Tests',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
            ],
            items: [
              {
                label: 'Search Content',
                link: '/contents',
                key: 'contents',
                group: 'Course',
                icon: 'search',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
              {
                label: 'Vocabulary Themes',
                link: '/vocabulary-themes',
                key: 'vocabulary-themes',
                group: 'Course',
                icon: 'container',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
              {
                label: 'Vocabularies',
                link: '/vocabularies',
                key: 'vocabularies',
                group: 'Course',
                icon: 'container',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
              {
                label: 'Grammars',
                link: '/grammars',
                key: 'grammars',
                group: 'Course',
                icon: 'tag',
              },
              {
                label: 'Courses',
                link: '/courses',
                group: 'Course',
                icon: 'book',
                key: 'courses',
              },
              {
                label: 'Modules',
                key: 'modules',
                link: '/modules',
                group: 'Course',
                icon: 'book',
              },
              {
                label: 'Module Customizations',
                key: 'module-customizations',
                link: '/module-customizations',
                group: 'Course',
                icon: 'picture',
                allowedFor: [Roles.ADMIN, Roles.DISTRIBUTOR_CONTENT_ADMIN],
              },
              {
                label: 'Draft Items Review',
                key: 'draft-items',
                link: '/draft-items-review',
                group: 'Course',
                icon: 'eye',
              },
              {
                label: 'Upload Content CSV',
                key: 'upload-content',
                link: '/upload-content',
                group: 'Course',
                icon: 'cloud-upload',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
              {
                label: 'Placement Test',
                key: 'placement-test',
                link: '/placement-test',
                group: 'Tests',
                icon: 'solution',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Placement Test Ruler',
                key: 'placement-test-ruler',
                link: '/placement-test-ruler',
                group: 'Tests',
                icon: 'solution',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Practice Test',
                key: 'practice-test',
                link: '/practice-test',
                group: 'Tests',
                icon: 'database',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Certification Test',
                key: 'certification-test-register',
                link: '/certification-test-register',
                group: 'Tests',
                icon: 'exception',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
            ],
          },
          {
            type: 'submenu',
            key: 'content-report',
            title: 'Content Reports',
            icon: 'control',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
            items: [
              {
                label: 'Placement Item History',
                key: 'placement-test-items-history',
                link: '/placement-test-items-history',
                group: 'Reports',
                icon: 'info-circle-o',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Unit Items Errors',
                key: 'reports-unit-errors',
                link: '/reports/unit-errors',
                group: 'Reports',
                icon: 'exclamation-circle-o',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
              {
                label: 'Items By Words',
                key: 'items-by-words',
                link: '/items-by-words',
                group: 'Reports',
                icon: 'file-text',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
              {
                label: 'Items By Word Count Limit',
                key: 'items-by-word-count-limit',
                link: '/items-by-word-count-limit',
                group: 'Reports',
                icon: 'file-text',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CONTENT_ADMIN],
              },
              {
                label: 'Unit Items Execution Stats',
                key: 'unit-items-execution-stats',
                link: '/unit-items-execution-stats',
                group: 'Reports',
                icon: 'warning',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Unit Average Execution Time',
                key: 'unit-average-execution-time',
                link: '/unit-average-execution-time',
                group: 'Reports',
                icon: 'hourglass',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Unit Ratings',
                key: 'unit-ratings',
                link: '/unit-ratings',
                group: 'Reports',
                icon: 'star',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Mastery Items Execution Stats',
                key: 'mastery-items-execution-stats',
                link: '/mastery-items-execution-stats',
                group: 'Reports',
                icon: 'warning',
                allowedFor: [Roles.CONTENT_ADMIN, Roles.ADMIN, Roles.SUPPORT],
              },
            ],
          },
          {
            type: 'menu',
            title: 'Certification Test',
            key: 'certification-test-executions',
            link: '/certification-test-executions',
            icon: 'contacts',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT, Roles.CERTIFICATION_TEST_PROFESSIONAL],
          },
          {
            type: 'menu',
            key: 'ranking',
            title: 'Ranking',
            icon: 'trophy',
            link: '/rankings',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
          },
          {
            type: 'submenu',
            key: 'reports',
            title: 'Reports',
            icon: 'filter',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
            items: [
              {
                label: 'Usage Stats',
                icon: 'pie-chart',
                key: 'usage-stats',
                link: '/usage-stats',
                allowedFor: [
                  Roles.ADMIN,
                  Roles.SUPPORT,
                  Roles.DISTRIBUTOR_MANAGER,
                  Roles.COMPANY_MANAGER,
                  Roles.SCHOOL_MANAGER,
                  Roles.SPEECHACE,
                ],
              },
              {
                label: 'Suspect Usage Alerts',
                icon: 'alert',
                link: '/suspect-usage-alerts',
                key: 'suspect-usage-alerts',
                allowedFor: [Roles.ADMIN, Roles.SUPPORT],
              },
              {
                label: 'Placement Test',
                icon: 'bar-chart',
                link: '/placement-test-report',
                key: 'placement-test-report',
                allowedFor: [
                  Roles.ADMIN,
                  Roles.DISTRIBUTOR_MANAGER,
                  Roles.SCHOOL_MANAGER,
                  Roles.COMPANY_MANAGER,
                  Roles.TEACHER,
                  Roles.SUPPORT,
                ],
              },
              {
                label: 'Student Close to Finish Course',
                link: '/student-close-to-finish-course',
                key: 'student-close-to-finish-course',
                allowedFor: [
                  Roles.ADMIN,
                  Roles.SUPPORT,
                  Roles.DISTRIBUTOR_MANAGER,
                  Roles.COMPANY_MANAGER,
                  Roles.SCHOOL_MANAGER,
                  Roles.TEACHER,
                ],
              },
              {
                label: 'Finished Courses',
                link: '/finished-courses',
                key: 'finished-courses',
                allowedFor: [
                  Roles.ADMIN,
                  Roles.SUPPORT,
                  Roles.DISTRIBUTOR_MANAGER,
                  Roles.COMPANY_MANAGER,
                  Roles.SCHOOL_MANAGER,
                  Roles.TEACHER,
                ],
              },
              {
                label: 'Active Students by Course',
                link: '/active-students-by-course',
                key: 'active-students-by-course',
                allowedFor: [
                  Roles.ADMIN,
                  Roles.SUPPORT,
                  Roles.DISTRIBUTOR_MANAGER,
                  Roles.COMPANY_MANAGER,
                  Roles.SCHOOL_MANAGER,
                  Roles.TEACHER,
                ],
              },
            ],
          },
          {
            type: 'menu',
            key: 'messages',
            link: '/messages',
            icon: 'message',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
            title: (
              <UnReadeMessageCountContainer>
                <span style={{ color: 'hsla(0,0%,100%,.65)' }}>Messages</span>
              </UnReadeMessageCountContainer>
            ),
          },
          {
            type: 'submenu',
            key: 'kpis',
            title: 'KPIs',
            icon: 'desktop',
            allowedFor: [Roles.ADMIN, Roles.SUPPORT],
            items: [
              {
                label: 'Customer Success',
                icon: 'solution',
                key: 'customer-succes',
                link: '/kpis/customer-success',
              },
              {
                label: 'Learning',
                icon: 'book',
                key: 'learning',
                link: '/kpis/learning',
              },
              {
                label: 'Content',
                icon: 'read',
                key: 'content',
                link: '/kpis/content',
              },
            ],
          },
          {
            type: 'menu',
            label: 'File Repository',
            key: 'file-repository',
            link: '/file-repository',
            icon: 'file',
            allowedFor: [Roles.DISTRIBUTOR_CONTENT_ADMIN],
          },
        ];

  render() {
    return (
      <Layout>
        <Layout.Header>
          <Menu items={this.menuItems} />
          <div
            style={{
              top: 0,
              right: 0,
              position: 'absolute',
              marginRight: '15px',
            }}
          >
            <Button icon="poweroff" onClick={this.handleLogout} />
          </div>
        </Layout.Header>
        <Layout.Content
          style={{
            padding: 10,
            minHeight: '100vh',
          }}
        >
          {this.props.children}
          <ConfirmDialogContainer />
        </Layout.Content>
        <PermissionValidator allowedFor={[Roles.DISTRIBUTOR_MANAGER, Roles.COMPANY_MANAGER]}>
          <MigrationDialogContainer />
          <WarningContractBlockDialogContainer />
          <BillReminderDialogContainer />
        </PermissionValidator>
      </Layout>
    );
  }
}

export default MainScene;
